import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { useGetNutritionistsService } from '../../services/get-nutritionists.service';
import { setIsSearchingByText } from '../../state/nutritionist-test.slice';

import { useStyles } from './nutritionist-search-text.styles';

export const NutritionistSearchText = () => {
  const [searchText, setSearchText] = useState('');

  const getNutritionistsService = useGetNutritionistsService();

  const classes = useStyles();

  const dispatch = useDispatch()

  const onSearchHandler = () => {
    const queryParams = `?mainFilter=${searchText}`;
    getNutritionistsService.mutate({ queryParams });
    dispatch(setIsSearchingByText(true))
  }

  const onTextChangeHandler = event => {
    const { value: searchText } = event.target;
    setSearchText(searchText);
  };

  const onKeyPressHandler = event => {
    if (event.key === 'Enter') {
      onSearchHandler();
    }
  }

  return (
    <Box component="section" className={classes.group}>
      <Box className={classes.searchGroup}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Busca a tu nutriólogo en todo el directorio
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          value={searchText}
          label="Busca por nombre o especialidad"
          onChange={onTextChangeHandler}
          onKeyDown={onKeyPressHandler}
        />
      </Box>
      <Button variant="contained" disabled={!searchText || getNutritionistsService.isLoading} onClick={onSearchHandler}>Buscar</Button>
    </Box>
  );
}